import Vue from "vue";
import Vuex from "vuex";
import VueCookie from "vue-cookie";
import { getUserInfoByToken } from "@/api/user.js";

Vue.use(Vuex);
Vue.use(VueCookie);

const store = new Vuex.Store({
    state: {
        token: "",
        userInfo: {}
    },
    getters: {
        id: state => {
            return state.userInfo.id;
        },
        deptId: state => {
            return state.userInfo.deptId;
        },
        flowId: state => {
            return state.userInfo.flowId;
        },
        deptName: state => {
            return state.userInfo.deptName;
        },
        roleNames: state => {
            return state.userInfo.roleNames
        }
    },
    mutations: {
        LOGIN(state, data) {
            state.userInfo = data;
        },
        LOGOUT(state, data) {
            state.userInfo = {};
            state.token = "";
        },
        GETTOKEN(state, data) {
            state.token = data;
            VueCookie.set("procuretoken", data);
        },
        GETUSERINFO: (state, data) => {
            state.token = VueCookie.get("procuretoken");
            state.userInfo = data;
        }
    },
    actions: {
        UserLogin({ commit }, data) {
            commit("LOGIN", data);
        },
        UserLogout({ commit }) {
            commit("LOGOUT");
        },
        GetToken({ commit }, data) {
            commit("GETTOKEN", data);
        },
        GetUserInfo({ commit }) {
            return getUserInfoByToken().then(res => {
                commit("GETUSERINFO", res.entUser);
            });
        }
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js